import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuHeader from "../header/MenuHeader";
import { AUTHOR_CRUMB } from "../../constants/BreadcrumConstants";
import { AUTHOR_BOOKS } from "../../constants/PageTitleConstants";
import { makeGetRequest } from "../../rest/RestService";
import { AUTHOR_BOOKS_URL } from "../../constants/APIEndpointConstants";
import { useLocation } from "react-router-dom";
import { AuthorNameSeparator } from "../../helper/AuthorNameSeparator";
import { linkHelper } from "../../helper/LinkHelper";
import { Loader } from "../general/Loader";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import React from "react";
import PageNotFound from "../not-found/PageNotFound";
import { sanitizeHTML } from "../../helper/SanitizeHTML";

const AuthorBooks = () => {
  const location = useLocation();
  const [books, setBooks] = useState({});
  const [loader, setLoader] = useState(true);
  const history = useHistory();
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const author_slug = new URLSearchParams(location.search).get("author_slug");
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    setLoader(true);
    if (hfData?.header) {
      makeGetRequest(`${AUTHOR_BOOKS_URL}${author_slug}`)
        .then((res) => setBooks(res.data))
        .catch((err) => setBooks({ error: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [location.search, author_slug, history, hfData?.header]);
  const handleAuthor = (author, author_links) => {
    const authorArray = AuthorNameSeparator(author)?.split(",");
    const newMap = authorArray.map((s, i) => ({
      url: author_links[i],
      title: s,
    }));
    return newMap;
  };
  const crumb = [
    AUTHOR_CRUMB,
    {
      title: `${books?.author_name}`,
      path: `/authorbio?author_slug=${author_slug}`,
    },
  ];
  const ogURL = `${process.env.REACT_APP_FRONT_URL}${location.pathname}${location.search}`;
  const ogImage = process.env.REACT_APP_POLITY_IMAGE;
  return (
    <>
      {loader ? (
        <Loader />
      ) : books?.header && !hfError ? (
        <>
          <Helmet>
            <title>{AUTHOR_BOOKS}</title>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={books?.header} />
            <meta property="og:url" content={ogURL} />
            <meta property="og:description" content={books?.header}></meta>
            <meta property="og:site_name" content="Polity" />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:secure_url" content={ogImage} />
          </Helmet>
          <Header data={hfData} />
          {books?.header && (
            <div>
              <MenuHeader
                title={books?.header}
                crumbs={[AUTHOR_CRUMB, { title: `${books?.author_name}` }]}
                containerClass="subject_bg"
                textColor="subject_intro_text"
                breadCrumbColor="subject_padding"
                labelColor="lable_hlight"
              />
              <div className="container-fluid subject_list_bg">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="container subject_padding">
                      <div className="row subject_highlights">
                        {books?.book_list?.map((book, i) => (
                          <div
                            key={i}
                            className="col-xs-12 col-sm-4 col-md-4 col-lg-4 book_container"
                            style={{ paddingTop: "10px", height: "379px" }}
                          >
                            <div className="pull-left slider_img_shadow">
                              {book.img ? (
                                <Link
                                  to={{
                                    pathname: `/bookdetail`,
                                    state: { crumb },
                                    search: `?book_slug=${book?.book_slug}`,
                                  }}
                                >
                                  <img
                                    className="book_cover_image"
                                    src={book?.img}
                                    alt=""
                                  />{" "}
                                </Link>
                              ) : (
                                <div className="cover_no_image">No Image</div>
                              )}
                            </div>
                            <div
                              className="highlight_book_title"
                              style={{ paddingTop: "20px" }}
                            >

  
                              {/*WEB-331 - fixing the title issue using dangerouslySetInnerHTML*/}

                              {/* {book?.title_book_url &&
                                book?.title_book_url !== "" &&
                                linkHelper({
                                  url: book?.title_book_url,
                                  title: book?.title,
                                })} */}
                              
                              {book?.title_book_url &&
                                book?.title_book_url !== "" && (
                                  <Link to={book?.title_book_url}>
                                    <span
                                      dangerouslySetInnerHTML={sanitizeHTML(
                                        book?.title
                                      )}
                                    />
                                  </Link>
                                )}
                            </div>                            
                            {book?.author && (
                              <div className="highlight_author_name">
                                {handleAuthor(
                                  book?.author,
                                  book?.author_links
                                )?.map((a, i, arr) =>
                                  linkHelper(a, i, arr.length)
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <Footer data={hfData} />
        </>
      ) : (
        <>
          <PageNotFound
            pageError={books?.error || hfError || books?.author_book?.message}
          />
        </>
      )}
    </>
  );
};
export default AuthorBooks;
